import { createTheme, Theme } from "@mui/material/styles";
import favicon from "./icons/favicon.ico";
import lightLogo from "./images/light_logo.svg";
import loginLogo from "./images/login_logo.svg";

const primaryColor = "#691e44";
const secondaryColor = "#ee303c";
const favIcon = favicon;
const appBarColor = "secondary.main";
const logoHeight = "60px";
const topBarLogoWidth = "auto";

// Augment the palette to include an ochre color
declare module "@mui/material/styles" {
  interface Palette {
    light: Palette["primary"];
  }

  interface PaletteOptions {
    light?: PaletteOptions["primary"];
  }
}

// Update the Button's color options to include an ochre option
declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    light: true;
  }
}

const theme: Theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
    light: {
      main: "#fff",
    },
    error: {
      main: "#e54142",
    },
    success: {
      main: "#2e7d32",
    },
    info: {
      main: "#0288d1",
    },
    divider: "rgba(0, 0, 0, 0.12)",
    background: {
      default: "#FAFAFA",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: "#f44336",
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          "& .MuiAlert-icon": {
            color: "inherit",
          },
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          "& .MuiGrid-item": {
            maxWidth: "100%",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: ["Franklin Gothic"].join(","),
  },
});

export default {
  mui: theme,
  favIcon: favIcon,
  appBarColor: appBarColor,
  lightLogo: lightLogo,
  loginLogo: loginLogo,
  logoHeight: logoHeight,
  topBarLogoWidth: topBarLogoWidth,
};
